import React from 'react'
import Cartproduct from '../components/Cartproduct'
import Mainlayout from '../layout/Mainlayout'
import cart from '../data/cart.json'
import Checkout from '../components/Checkout'
import { TiWarningOutline } from "react-icons/ti";

export default function Cart() {


    const a = []
    function price(afterdiscount) {
        return afterdiscount
    }
    function discount() {
        var sum = 0;
        for (let i = 0; i < a.length; i++) {
            sum += a[i];
        }
        if (sum >= 100) {
            const dis = ((sum / 100) * 0.2) * 100
            return price(sum - dis)
        }
        else {

            return price(sum)
        }
    }
    function disc() {
        var sum = 0;
        for (let i = 0; i < a.length; i++) {
            sum += a[i];
        }
        if (sum >= 100) {
            const dis = ((sum / 100) * 0.2) * 100
            return dis
        }
        else {
            return 0
        }
    }



    return (
        <Mainlayout>

            <div className='md:p-5 p-2 bg-dwam min-h-screen flex flex-col md:flex-row'>
                <div className='md:w-1/2'>

                    {cart.map((item) => {
                        return (
                            <div className=' rounded-lg px-2'>
                                <Cartproduct item={item} />
                            </div>
                        )
                    })}
                </div>
                <div className='p-2 m-2 md:w-1/2 text-c7 '>
                    {
                        cart.length !== 0 ? 
                            (

                                <h1 className='w-full text-center text-3xl text-shasham'>Oreder Summary</h1>
                            )
                            :
                            (
                                <>
                                    <h1 className=' absolute flex flex-col justify-center items-center w-fit mx-auto p-5 rounded-full right-0 left-0  text-center text-yellow-500'>
                                        <TiWarningOutline className='w-full h-full drop-shadow-2xl'/>
                                        <p className='p-2 text-2xl md:text-3xl'>هیچ لە سەبەتەکەت دا نیە&nbsp;&nbsp;</p>
                                    </h1>
                                </>
                            )
                    }
                    {cart.map((item) => {

                        a.push(JSON.parse(item.price))
                        return (
                            <>
                                <Checkout item={item} />
                            </>
                        )
                    })}
                    {
                        cart.length !== 0 ? 
                            (
                                <>

                                    <div className='flex justify-between p-2'>
                                        <p className='text-xl text-yakam font-extrabold'>discount</p>
                                        <p className='text-xl text-yakam font-extrabold'>{disc()}$</p>

                                    </div>
                                    <div className='flex justify-between p-2 border-t-2'>
                                        <p className='text-xl text-yakam font-extrabold'>Total</p>
                                        <p className='text-xl text-yakam font-extrabold'>{discount()}$</p>

                                    </div>
                                    <button type='submit' className="shadow-sm shadow-penjam relative inline-flex items-center justify-center p-0.5 mb-2 mr-2 w-full overflow-hidden text-xl font-medium text-chwaram rounded-lg group bg-gradient-to-br from-penjam to-chwaram group-hover:from-penjam group-hover:to-chwaram hover:text-black  focus:ring-4 focus:outline-none focus:ring-green-200 ">
                                        <span className="shadow-sm shadow-penjam relative w-full px-5 py-2.5 transition-all ease-in duration-75 bg-yakam  rounded-md group-hover:bg-opacity-0">
                                            Checkout
                                        </span>
                                    </button>
                                </>
                            )
                            :
                            (
                                null
                            )
                    }
                </div>
            </div>

        </Mainlayout>
    )
}
